import { create } from 'zustand';
import { User } from '@packet/management/src/DTO/user';

interface UserEditModalState {
  isOpen: boolean;
  user: User | null;
  openUserEdit: (user: User) => void;
  closeUserEdit: () => void;
}

export const useUserEditModalStore = create<UserEditModalState>((set) => ({
  isOpen: false,
  user: null,

  openUserEdit: (user: User) => {
    set({
      isOpen: true,
      user,
    });
  },

  closeUserEdit: () => {
    set({
      isOpen: false,
      user: null,
    });
  },
}));
